/**************************************************
 * Nombre:       Tarjeta_Proceso_Adminision
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, IconButton, Typography} from "@mui/material";
import {theme} from "../../Tema";
import {useDialogo} from "../../Modulo_Dialogos_2025/Hooks/useDialogo";
import Dialogo_Wass from "../Dialogos/Dialogo_Wass";
import {useState} from "react";
import Dialogo_Formulario_Interactivo from "../Dialogos/Dialogo_Formulario_Interactivo";
import {useNavigate} from "react-router-dom";
import {useResponsive} from "../../Modulo_responsive/Hooks/useResponsive";


const Tarjeta_Proceso_Adminision = ({item, index}) => {
    const {sCell} = useResponsive()
    const navigate = useNavigate();
    const {Dialogo, abrir} = useDialogo({Componente: Dialogo_Wass, titulo: item.nombre})
    const {Dialogo:DialogoInter, abrir:abrirInter} = useDialogo({Componente: Dialogo_Formulario_Interactivo, titulo: ''})
    const [arriba, setArriba] = useState(false)

    const procesarClick = () => {

        switch (item.nombre) {

            case 'Elige tu programa' :
                navigate('/Escuelas')
                break

            case 'Registra tus datos' :
                abrirInter()
                break

            case 'Entrega documentos' :
            case 'Realiza tu matrícula' :

                abrir({asunto: item.camino})
                break

        }

    }

    return (
        <>
            <Dialogo/>
            <DialogoInter/>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                onPointerOver={() => setArriba(true)}
                onPointerLeave={() => setArriba(false)}
                onClick={() => procesarClick()}
                sx={{
                    cursor: 'pointer',
                }}
            >


                <Grid container size={{xs: 2.5, sm: 12, md: 1.5}} sx={{justifyContent: 'flex-start'}}>
                    <IconButton sx={{
                        backgroundColor: arriba ? theme.palette.primary.main : '#fff',
                        border: 2,
                        width: 60,
                        height: 62,
                        borderColor: arriba ? theme.palette.secondary.main : theme.palette.primary.main,
                    }}>
                        <Typography sx={{
                            color: arriba  ? '#fff' : theme.palette.primary.main,
                            fontWeight: 600,
                            fontSize: 24
                        }}>{index + 1}</Typography>
                    </IconButton>
                </Grid>

                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    size={{xs: 9, sm: 12, md: 10}}>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                        <Typography sx={{
                            fontWeight: 800, color: theme.palette.primary.main, fontSize: 18
                        }}>{item.nombre}</Typography>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                        <Typography sx={{
                            fontWeight: 300, fontSize: sCell ? 16 : 18, lineHeight: 1.1
                        }}>{item.descripcion}</Typography>
                    </Grid>

                </Grid>

            </Grid>

        </>
    )

}
export default Tarjeta_Proceso_Adminision